import React, { Component } from 'react';

import {PeopleList} from './PeopleList';
import PeopleCreate from "./PeopleCreate";
import PeopleEdit from './PeopleEdit';
import PersonIcon from '@material-ui/icons/Person';
import SupervisorIcon from "../SupervisorIcon";
import en_messages from './en_messages';
import PeopleIcon from "./PeopleIcon";
import SettingsIcon from '@material-ui/icons/Settings';
import PeopleImport from "./PeopleImport";
import { Route } from 'react-router-dom';



const menuItems = [];
menuItems.push({parentMenu: 'admin', menuAuth: 'admin', name: 'importCsv', route: 'peopleImportCsv', parentMenuIcon: (<PeopleIcon/>), icon: (<SettingsIcon/>)});

const customRoutes = [];

// noLayout for a non layout route
customRoutes.push(<Route exact path="/peopleImportCsv" component={PeopleImport} />);


export const messages = {
    en: en_messages
}

export default ({
    RESOURCE: 'people',
    TITLE: 'Operator |||| Operators',
    LIST: PeopleList,
    LISTAUTH: 'supervisor',
    SHOW: null,
    CREATE: PeopleCreate,
    CREATEAUTH: 'supervisor',
    EDIT: PeopleEdit,
    EDITAUTH: 'supervisor',
    ICON: (<PersonIcon/>),
    messages: messages,
    parentMenu: 'supervisor',
    parentMenuIcon: (<SupervisorIcon/>),
    disabled: false,
    menuHidden: false,
    customMenuItems: menuItems,
    customRoutes: customRoutes,
    menuAuth: 'supervisor'
});


